export default __webpack_public_path__ + "static/media/First.5815fbb8.png";